import type { Target, Transition } from 'motion/react';

const DEVICE_X_TIMES = [
  0, 0.0833, 0.1667, 0.25, 0.3333, 0.4167, 0.5, 0.5833, 0.6667, 0.75, 0.8333,
  0.9167, 1,
];

export const DEVICE_ANIMATE: Target = {
  x: [
    0, -1.401, -1.981, 0.015, 1.909, 1.418, -0.315, -1.418, -1.974, -0.015, 1.9,
    1.401, 0,
  ],

  y: [0, -10, 0],
};

export const DEVICE_INITIAL: Target = {
  x: 0,
  y: 0,
  opacity: 0,
};

export const DEVICE_ANIMATE_VISIBLE: Target = {
  ...DEVICE_ANIMATE,
  opacity: 1,
};

export const DEVICE_ANIMATE_STILL: Target = {
  opacity: 1,
};

export const DEVICE_EXIT: Target = {
  opacity: 0,
};

export const DEVICE_STILL_TRANSITION: Transition = {
  opacity: { duration: 0.2, ease: 'easeInOut' },
};

export const DEVICE_TRANSITION: Transition = {
  opacity: { duration: 0.2, ease: 'easeInOut' },

  x: {
    duration: 6,
    times: DEVICE_X_TIMES,
    ease: 'linear',
    repeat: Number.POSITIVE_INFINITY,
    repeatType: 'reverse',
  },

  y: {
    duration: 6,
    times: [0, 0.5, 1],
    ease: [0.37, 0, 0.63, 1],
    repeat: Number.POSITIVE_INFINITY,
    repeatType: 'reverse',
  },
};
